import React from 'react';
import { t } from 'ttag';
import PropTypes from 'prop-types';

function Backdrop({ closeOverlay }) {
  return (
    <div
      className="fixed inset-0 z-10 cursor-pointer overflow-hidden bg-black opacity-50"
      role="button"
      tabIndex={0}
      aria-label={t`Close Customization Overlay`}
      onClick={() => closeOverlay()}
    />
  );
}

Backdrop.propTypes = {
  closeOverlay: PropTypes.func.isRequired,
};

Backdrop.defaultProps = {};

export default Backdrop;
